import VerEx from 'verbal-expressions'
import { expressionValues } from './expessions'

/**
 * Generate a unique ID, with option prefix
 *
 * @returns {string} id
 */
let idCounter = 0

export function id() {
    const id = ++idCounter
    const prefix = Math.random().toString(36).substr(2, 9)
    return prefix + id
}

/**
 * Generate verbal expression
 *
 * @param {array} expressions
 * @return {string} regex
 */

export function regex(expressions) {
    let verEx = new VerEx

    expressions.forEach(({ expression, value }) => {
        if ((expression === 'range' && value.split('-').length !== 2) || (expressionValues.includes(expression) && ! value)) return

        if (expressionValues.includes(expression)) {
            verEx[expression].apply(verEx, value.split('-'))
        } else {
            verEx[expression]()
        }
    })

    return verEx
}

/**
 * Unescape html characters
 *
 * @param {string} string
 * @return {string} html
 */
export function html(string) {
    const el = document.querySelector('.content-matches')

    if (el) el.innerHTML = string
}



// WEBPACK FOOTER //
// ./src/scripts/utilities/helpers.js